import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getBeneficiaryDetails = ({ groupId = null, userId = null }) =>
  call(websocketFetch, 'get_beneficiary_details', {
    group_id: groupId,
    user_id: userId,
  });
